import React, {FunctionComponent} from "react";
import {Alert} from "@mui/material";

export const ErrorMessage: FunctionComponent<ErrorMessageProps> = props => {
    return <Alert severity="error" role="alert-message">{props.message}</Alert>;
}

export interface ErrorMessageProps {
    message: string;
}